import { RootState } from '~/reducers';
import { RenewalPlanState } from '~/reducers/vendors/creditRenewalReducer';

export const getRenewalPlans = (state: RootState) => state.vendors.renewalPlan.byStorefrontUuid;

export const getRenewalPlanByStorefrontUuid = (
  state: RootState,
  storefrontUuid: string
): RenewalPlanState | undefined => {
  return state.vendors.renewalPlan.byStorefrontUuid[storefrontUuid];
};
